/**
 * @since 0.15.0
 * @component
 */
export default (() => [
  0, 4, 8, 12, 16, 20, 24, 28, 32, 36,
  48, 60, 72, 84, 96, 108,
])();
